// extracted by mini-css-extract-plugin
export default {"nbWatchlistPage":"WatchlistPage_nbWatchlistPage__hJ6QL"};